var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvenience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C33.0609 32 34.0783 32.4214 34.8284 33.1716C35.5786 33.9217 36 34.9391 36 36C36 37.0609 35.5786 38.0783 34.8284 38.8284C34.0783 39.5786 33.0609 40 32 40C30.9391 40 29.9217 39.5786 29.1716 38.8284C28.4214 38.0783 28 37.0609 28 36C28 33.78 29.78 32 32 32ZM0 0H6.54L8.42 4H38C38.5304 4 39.0391 4.21071 39.4142 4.58579C39.7893 4.96086 40 5.46957 40 6C40 6.34 39.9 6.68 39.76 7L32.6 19.94C31.92 21.16 30.6 22 29.1 22H14.2L12.4 25.26L12.34 25.5C12.34 25.6326 12.3927 25.7598 12.4864 25.8536C12.5802 25.9473 12.7074 26 12.84 26H36V30H12C10.9391 30 9.92172 29.5786 9.17157 28.8284C8.42143 28.0783 8 27.0609 8 26C8 25.3 8.18 24.64 8.48 24.08L11.2 19.18L4 4H0V0ZM12 32C13.0609 32 14.0783 32.4214 14.8284 33.1716C15.5786 33.9217 16 34.9391 16 36C16 37.0609 15.5786 38.0783 14.8284 38.8284C14.0783 39.5786 13.0609 40 12 40C10.9391 40 9.92172 39.5786 9.17157 38.8284C8.42143 38.0783 8 37.0609 8 36C8 33.78 9.78 32 12 32ZM30 18L35.56 8H10.28L15 18H30Z",
    fill: "#85B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenience);
export default __webpack_public_path__ + "static/media/Convenience.272be3f31f22ac06d34b2b07b56ed64b.svg";
export { ForwardRef as ReactComponent };